/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdditionalType } from './AdditionalType';
import {
    AdditionalTypeFromJSON,
    AdditionalTypeFromJSONTyped,
    AdditionalTypeToJSON,
} from './AdditionalType';
import type { EnterprisePrice } from './EnterprisePrice';
import {
    EnterprisePriceFromJSON,
    EnterprisePriceFromJSONTyped,
    EnterprisePriceToJSON,
} from './EnterprisePrice';
import type { GraduatedPrice } from './GraduatedPrice';
import {
    GraduatedPriceFromJSON,
    GraduatedPriceFromJSONTyped,
    GraduatedPriceToJSON,
} from './GraduatedPrice';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Pricing } from './Pricing';
import {
    PricingFromJSON,
    PricingFromJSONTyped,
    PricingToJSON,
} from './Pricing';
import type { TenantAdditionalDetails } from './TenantAdditionalDetails';
import {
    TenantAdditionalDetailsFromJSON,
    TenantAdditionalDetailsFromJSONTyped,
    TenantAdditionalDetailsToJSON,
} from './TenantAdditionalDetails';
import type { ThresholdPrice } from './ThresholdPrice';
import {
    ThresholdPriceFromJSON,
    ThresholdPriceFromJSONTyped,
    ThresholdPriceToJSON,
} from './ThresholdPrice';
import type { Unit } from './Unit';
import {
    UnitFromJSON,
    UnitFromJSONTyped,
    UnitToJSON,
} from './Unit';

/**
 * 
 * @export
 * @interface Additional
 */
export interface Additional {
    /**
     * 
     * @type {string}
     * @memberof Additional
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof Additional
     */
    orderNr?: number;
    /**
     * 
     * @type {AdditionalType}
     * @memberof Additional
     */
    type?: AdditionalType;
    /**
     * 
     * @type {string}
     * @memberof Additional
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof Additional
     */
    readonly description?: string;
    /**
     * 
     * @type {TenantAdditionalDetails}
     * @memberof Additional
     */
    tenantDetails?: TenantAdditionalDetails;
    /**
     * 
     * @type {Pricing}
     * @memberof Additional
     */
    pricing?: Pricing;
    /**
     * 
     * @type {Price}
     * @memberof Additional
     */
    price?: Price;
    /**
     * 
     * @type {boolean}
     * @memberof Additional
     */
    fixedQuantity?: boolean;
    /**
     * 
     * @type {Array<ThresholdPrice>}
     * @memberof Additional
     */
    thresholdPrices?: Array<ThresholdPrice>;
    /**
     * 
     * @type {Array<GraduatedPrice>}
     * @memberof Additional
     */
    graduatedPrices?: Array<GraduatedPrice>;
    /**
     * 
     * @type {EnterprisePrice}
     * @memberof Additional
     */
    enterprisePrice?: EnterprisePrice;
    /**
     * 
     * @type {Unit}
     * @memberof Additional
     */
    unit?: Unit;
    /**
     * 
     * @type {string}
     * @memberof Additional
     */
    productImageId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Additional
     */
    storeAvailability?: boolean;
}

/**
 * Check if a given object implements the Additional interface.
 */
export function instanceOfAdditional(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdditionalFromJSON(json: any): Additional {
    return AdditionalFromJSONTyped(json, false);
}

export function AdditionalFromJSONTyped(json: any, ignoreDiscriminator: boolean): Additional {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'orderNr': !exists(json, 'orderNr') ? undefined : json['orderNr'],
        'type': !exists(json, 'type') ? undefined : AdditionalTypeFromJSON(json['type']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'tenantDetails': !exists(json, 'tenantDetails') ? undefined : TenantAdditionalDetailsFromJSON(json['tenantDetails']),
        'pricing': !exists(json, 'pricing') ? undefined : PricingFromJSON(json['pricing']),
        'price': !exists(json, 'price') ? undefined : PriceFromJSON(json['price']),
        'fixedQuantity': !exists(json, 'fixedQuantity') ? undefined : json['fixedQuantity'],
        'thresholdPrices': !exists(json, 'thresholdPrices') ? undefined : ((json['thresholdPrices'] as Array<any>).map(ThresholdPriceFromJSON)),
        'graduatedPrices': !exists(json, 'graduatedPrices') ? undefined : ((json['graduatedPrices'] as Array<any>).map(GraduatedPriceFromJSON)),
        'enterprisePrice': !exists(json, 'enterprisePrice') ? undefined : EnterprisePriceFromJSON(json['enterprisePrice']),
        'unit': !exists(json, 'unit') ? undefined : UnitFromJSON(json['unit']),
        'productImageId': !exists(json, 'productImageId') ? undefined : json['productImageId'],
        'storeAvailability': !exists(json, 'storeAvailability') ? undefined : json['storeAvailability'],
    };
}

export function AdditionalToJSON(value?: Additional | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'orderNr': value.orderNr,
        'type': AdditionalTypeToJSON(value.type),
        'tenantDetails': TenantAdditionalDetailsToJSON(value.tenantDetails),
        'pricing': PricingToJSON(value.pricing),
        'price': PriceToJSON(value.price),
        'fixedQuantity': value.fixedQuantity,
        'thresholdPrices': value.thresholdPrices === undefined ? undefined : ((value.thresholdPrices as Array<any>).map(ThresholdPriceToJSON)),
        'graduatedPrices': value.graduatedPrices === undefined ? undefined : ((value.graduatedPrices as Array<any>).map(GraduatedPriceToJSON)),
        'enterprisePrice': EnterprisePriceToJSON(value.enterprisePrice),
        'unit': UnitToJSON(value.unit),
        'productImageId': value.productImageId,
        'storeAvailability': value.storeAvailability,
    };
}

